import { render, staticRenderFns } from "./WhatsappTestPage.vue?vue&type=template&id=40b4cf33&scoped=true"
import script from "./WhatsappTestPage.vue?vue&type=script&lang=js"
export * from "./WhatsappTestPage.vue?vue&type=script&lang=js"
import style0 from "./WhatsappTestPage.vue?vue&type=style&index=0&id=40b4cf33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b4cf33",
  null
  
)

export default component.exports